<template>
  <a-drawer :maskClosable="false" width="80%" title="详情" placement="right" :closable="true" :visible="visible"
    @close="onClose">
    <a-tabs @change="callback" :activeKey="active" type="card">
      <a-tab-pane :key="1" tab="基本信息">
        <div v-if="form && form.id">
          <a-card title="基础信息" :bordered="true">
            <a-descriptions :column="1" title="" class="full-width-descriptions">
              <a-descriptions-item :label="(form.type == 1
                ? '企业品牌'
                : form.type == 2
                  ? '经销商'
                  : form.type == 3
                    ? '分销商'
                    : form.type == 0
                      ? '管理员'
                      : '区域') + '名称'
                ">
                {{ form.name }}
              </a-descriptions-item>
              <a-descriptions-item label="联系人"> {{ form.contacts }} </a-descriptions-item>
              <a-descriptions-item label="联系电话"> {{ form.mobile }}</a-descriptions-item>
              <a-descriptions-item label="区域数" v-if="form.type == 0 || form.type == 1">
                {{ dataForm.statResult.regionCount }}
              </a-descriptions-item>
              <a-descriptions-item label="设备数" v-if="form.statResult">
                {{ form.statResult.devCount }}
              </a-descriptions-item>
              <a-descriptions-item label="短信余额" v-if="form.type == 0 || form.type == 1">
                {{ dataForm.smsBalance }}
              </a-descriptions-item>
              <a-descriptions-item label="短信使用数" v-if="form.type == 0 || form.type == 1">
                {{ dataForm.smsUse }}
              </a-descriptions-item>
              <a-descriptions-item label="统一信用代码"> {{ form.socialCreditCode }} </a-descriptions-item>
              <a-descriptions-item label="编号"> {{ form.code }} </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card title="经营信息" :bordered="true" style="margin-top: 20px;">
            <a-descriptions :column="1" title="" class="full-width-descriptions">
              <a-descriptions-item label="招牌名称"> {{ form.referredName }} </a-descriptions-item>
              <a-descriptions-item label="营业时间"> {{ form.startTimes }} </a-descriptions-item>
              <a-descriptions-item label="客服电话"> {{ form.customerMoblie }} </a-descriptions-item>
              <a-descriptions-item label="营业天" :span="2"> {{ form.businessDay }} </a-descriptions-item>
              <a-descriptions-item label="评价选项" :span="4"> {{ form.evaluateOption }} </a-descriptions-item>
              <a-descriptions-item label="详细地址" :span="2">
                {{ form.province }} {{ form.city }}{{ form.area }}{{ form.address }}</a-descriptions-item>
              <a-descriptions-item label="质保承诺" :span="2"> {{ form.commitmentIntroduce }} </a-descriptions-item>
              <a-descriptions-item label="分享介绍" :span="2" v-if="form.type == 0 || form.type == 1"> {{
                form.serviceIntroduce }} </a-descriptions-item>
              <a-descriptions-item label="备注" :span="2"> {{ form.remark }} </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <a-card title="其他信息" :bordered="true" style="margin-top: 20px;">
            <a-descriptions :column="1" title="" class="full-width-descriptions">
              <a-descriptions-item label="评价选项" :span="4"> {{ form.evaluateOption }} </a-descriptions-item>
              <a-descriptions-item label="详细地址" :span="2">
                {{ form.province }} {{ form.city }}{{ form.area }}{{ form.address }}</a-descriptions-item>
              <a-descriptions-item label="质保承诺" :span="2"> {{ form.commitmentIntroduce }} </a-descriptions-item>
              <a-descriptions-item label="分享介绍" :span="2" v-if="form.type == 0 || form.type == 1"> {{
                form.serviceIntroduce }} </a-descriptions-item>
              <!-- <a-descriptions-item label="备注" :span="2"> {{ form.remark }} </a-descriptions-item> -->
            </a-descriptions>
          </a-card>
             <a-card title="图片信息" :bordered="true" style="margin-top: 20px;">
            <a-descriptions :column="1" title="" class="full-width-descriptions">
              <a-descriptions-item label="附件图片" :span="4">
                <div v-viewer>
                  <img @error="
                    (e) => {
                      e.target.src = errorImage
                    }
                  " :src="$url + item" alt="" v-for="(item, index) in form.fileInfos" :key="index" />
                </div>
              </a-descriptions-item>
              <a-descriptions-item label="公司logo">
                <div v-viewer>
                  <img @error="
                    (e) => {
                      e.target.src = errorImage
                    }
                  " :src="$url + form.logoImg" alt="" v-if="form.logoImg" />
                </div>
              </a-descriptions-item>
              <a-descriptions-item label="公司电子服务章">
                <div v-viewer>
                  <img @error="
                    (e) => {
                      e.target.src = errorImage
                    }
                  " :src="$url + form.stampImg" alt="" v-if="form.stampImg" />
                </div>
              </a-descriptions-item>
            </a-descriptions>
          </a-card>
          <!-- <a-descriptions :column="4" title="" class="full-width-descriptions">
            <a-descriptions-item :label="(form.type == 1
              ? '企业品牌'
              : form.type == 2
                ? '经销商'
                : form.type == 3
                  ? '分销商'
                  : form.type == 0
                    ? '管理员'
                    : '区域') + '名称'
              ">
              {{ form.name }}
            </a-descriptions-item>
            <a-descriptions-item label="联系人"> {{ form.contacts }} </a-descriptions-item>
            <a-descriptions-item label="联系电话"> {{ form.mobile }}</a-descriptions-item>
            <a-descriptions-item label="区域数" v-if="form.type == 0 || form.type == 1">
              {{ dataForm.statResult.regionCount }}
            </a-descriptions-item>
            <a-descriptions-item label="设备数" v-if="form.statResult">
              {{ form.statResult.devCount }}
            </a-descriptions-item>
            <a-descriptions-item label="短信余额" v-if="form.type == 0 || form.type == 1">
              {{ dataForm.smsBalance }}
            </a-descriptions-item>
            <a-descriptions-item label="短信使用数" v-if="form.type == 0 || form.type == 1">
              {{ dataForm.smsUse }}
            </a-descriptions-item>
            <a-descriptions-item label="统一信用代码"> {{ form.socialCreditCode }} </a-descriptions-item>
            <a-descriptions-item label="编号"> {{ form.code }} </a-descriptions-item>
            <a-descriptions-item label="招牌名称"> {{ form.referredName }} </a-descriptions-item>
            <a-descriptions-item label="营业时间"> {{ form.startTimes }} </a-descriptions-item>
            <a-descriptions-item label="客服电话"> {{ form.customerMoblie }} </a-descriptions-item>
            <a-descriptions-item label="营业天" :span="2"> {{ form.businessDay }} </a-descriptions-item>
            <a-descriptions-item label="评价选项" :span="4"> {{ form.evaluateOption }} </a-descriptions-item>
            <a-descriptions-item label="详细地址" :span="2">
              {{ form.province }} {{ form.city }}{{ form.area }}{{ form.address }}</a-descriptions-item>
            <a-descriptions-item label="质保承诺" :span="2"> {{ form.commitmentIntroduce }} </a-descriptions-item>
            <a-descriptions-item label="分享介绍" :span="2" v-if="form.type == 0 || form.type == 1"> {{
              form.serviceIntroduce }} </a-descriptions-item>
            <a-descriptions-item label="备注" :span="2"> {{ form.remark }} </a-descriptions-item>
            <a-descriptions-item label="附件图片" :span="4">
              <div v-viewer>
                <img @error="
                  (e) => {
                    e.target.src = errorImage
                  }
                " :src="$url + item" alt="" v-for="(item, index) in form.fileInfos" :key="index" />
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="背景图">
              <div v-viewer>
                <img @error="
                  (e) => {
                    e.target.src = errorImage
                  }
                " :src="$url + form.backdropImg" alt="" v-if="form.backdropImg" />
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="公司logo">
              <div v-viewer>
                <img @error="
                  (e) => {
                    e.target.src = errorImage
                  }
                " :src="$url + form.logoImg" alt="" v-if="form.logoImg" />
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="公司电子服务章">
              <div v-viewer>
                <img @error="
                  (e) => {
                    e.target.src = errorImage
                  }
                " :src="$url + form.stampImg" alt="" v-if="form.stampImg" />
              </div>
            </a-descriptions-item>
          </a-descriptions> -->
        </div>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="区域" v-if="hasPermission('system:qu:one')">
        <Regin :isOperate="false" :tenantId="form.id" v-if="form.id && active == 2 && visible"></Regin>
      </a-tab-pane>
      <!-- <a-tab-pane :key="4" tab="分销商"> Content of Tab Pane 3 </a-tab-pane> -->
      <template v-if="form.type == 1 || form.type == 0">
        <a-tab-pane :key="3" tab="经销商" v-if="hasPermission('system:jing:one')">
          <tenantTwo :isOperate="false" v-if="form.id && active == 3 && visible" :firmId="form.id"></tenantTwo>
        </a-tab-pane>
        <a-tab-pane :key="4" tab="设备" v-if="hasPermission('system:she:one')">
          <Device :isOperate="false" v-if="form.id && active == 4 && visible" :tenantFirmId="form.id"></Device>
        </a-tab-pane>
        <a-tab-pane :key="5" tab="验收员" v-if="hasPermission('system:yan:one')">
          <User :isTree="false" :type="0" :tenantId="form.id" v-if="form.id && active == 5" :tenantFirmId="form.id">
          </User>
        </a-tab-pane>
        <a-tab-pane :key="6" tab="水工" v-if="hasPermission('system:shui:one')">
          <User :isTree="false" :type="1" v-if="form.id && active == 6 && visible" :tenantId="form.id"
            :tenantFirmId="form.id"></User>
        </a-tab-pane>
        <a-tab-pane :key="8" tab="订单" v-if="hasPermission('system:ding:one')">
          <Dispatch :isOperate="false" v-if="form.id && active == 8 && visible" :tenantFirmId="form.id"></Dispatch>
        </a-tab-pane>
        <a-tab-pane :key="7" tab="短信清单" v-if="hasPermission('system:sms:list')">
          <Sms :id="form.id" @changeBack="changeBack" v-if="form.id && active == 7"></Sms>
        </a-tab-pane>
        <!-- <a-tab-pane :key="9" tab="设备参数" v-if="hasPermission('system:sms:list')">
          <Parameter :tenantId="form.id" v-if="form.id && active==9"></Parameter>
        </a-tab-pane> -->
      </template>
      <template v-if="form.type == 2">
        <a-tab-pane :key="3" tab="分销商" v-if="hasPermission('system:jing:two')">
          <tenantThree :isOperate="false" :tenantId="form.id"
            v-if="form.id && active == 3 && form.type == 2 && visible"></tenantThree>
        </a-tab-pane>
        <a-tab-pane :key="4" tab="设备" v-if="hasPermission('system:she:two')">
          <Device :isOperate="false" v-if="form.id && active == 4 && visible" :tenantId="form.id"></Device>
        </a-tab-pane>
        <a-tab-pane :key="5" tab="验收员" v-if="hasPermission('system:yan:two')">
          <User :isTree="false" :type="0" :tenantId="form.id" v-if="form.id && active == 5 && visible"></User>
        </a-tab-pane>
        <a-tab-pane :key="6" tab="水工" v-if="hasPermission('system:shui:two')">
          <User :isTree="false" :type="1" :tenantId="form.id" v-if="form.id && active == 6 && visible"></User>
        </a-tab-pane>
        <a-tab-pane :key="8" tab="订单" v-if="hasPermission('system:ding:two')">
          <Dispatch :isOperate="false" :tenantId="form.id" v-if="form.id && active == 8 && visible"></Dispatch>
        </a-tab-pane>
      </template>
      <!-- <a-tab-pane :key="8" tab="积分规则"> <PointsRule :id="form.id"></PointsRule> </a-tab-pane> -->
    </a-tabs>
  </a-drawer>
</template>
<script>
import { getTenant } from '@/api/system/tenant'
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
import Regin from '../../pressure/region'
import Sms from '../../pressure/sms'
import PointsRule from '../../pressure/pointsRule'
import Device from '../../pressure/device/index.vue'
import Dispatch from '../../pressure/dispatch/index.vue'
import User from '../../system/user/index'
import tenantThree from './tenantThree'
import Parameter from '../../pressure/parameter'
import { tableMixin } from '@/store/table-mixin'
export default {
  mixins: [tableMixin],
  name: 'Post',
  components: {
    Regin,
    tenantTwo: () => import('./tenantTwo.vue'), // 正确引用自身
    Device,
    Sms,
    PointsRule,
    User,
    Dispatch,
    tenantThree,
    Parameter,
  },
  data() {
    return {
      visible: false,
      isBack: false,
      form: {},
      dataForm: {},
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      options: [
        { id: 1, name: '周一' },
        { id: 2, name: '周二' },
        { id: 3, name: '周三' },
        { id: 4, name: '周四' },
        { id: 5, name: '周五' },
        { id: 6, name: '周六' },
        { id: 7, name: '周日' },
      ],
      evaluationOptions: [
        { value: 1, label: '商品评价' },
        { value: 2, label: '店家服务态度' },
        { value: 3, label: '安装评价' },
        { value: 4, label: '验收评价' },
        { value: 5, label: '服务评价' },
        { value: 6, label: '回访评价' },
        { value: 7, label: '服务人员形象评价' },
        { value: 8, label: '对服务流程讲解' },
        { value: 9, label: '管路检查及丝堵检查' },
        { value: 10, label: '管道真伪查询' },
        { value: 11, label: '打压试验' },
        { value: 12, label: ' 检查管路漏水、虚焊、漏焊' },
        { value: 13, label: ' 是否张贴关闭总阀及温馨提示' },
        { value: 14, label: '拍摄全景管路图' },
      ],
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
    }
  },
  filters: {},
  created() {
    console.log(this.router, '111111222')

    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    init(e, index) {
      this.isBack = false
      console.log(e, index, 'sdd的点点滴滴')
      getTenant(e.id).then((res) => {
        const startTime = this.convertMinutes(res.data.startTime)
        const endTime = this.convertMinutes(res.data.endTime)
        const arr = []
        const array = []
        if (res.data.businessDays && res.data.businessDays.length) {
          res.data.businessDays.forEach((v) => {
            this.options.forEach((item) => {
              if (v == item.id) {
                arr.push(item.name)
              }
            })
          })
          res.data.businessDay = arr.join(',')
        }
        if (res.data.evaluateOptions && res.data.evaluateOptions.length) {
          res.data.evaluateOptions.forEach((v) => {
            this.evaluationOptions.forEach((item) => {
              if (v == item.value) {
                array.push(item.label)
              }
            })
          })
          res.data.evaluateOption = array.join(',')
        }
        res.data.startTimes = startTime + '-' + endTime
        this.form = res.data
        this.dataForm = e
        this.form.panoramaImg = null
        this.active = index
        this.visible = true
      })
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60) // 计算小时
      const remainingMinutes = minutes % 60 // 计算剩余的分钟
      return `${hours > 10 ? hours : '0' + hours}:${remainingMinutes > 10 ? remainingMinutes : '0' + remainingMinutes}`
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage

      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      this.visible = false
      this.form.id = ''
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      console.log(e, '顶顶顶顶')
      this.active = e
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {

            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() { },
      })
    },
    changeBack() {
      this.isBack = true
      console.log(1112222, '测试顶顶顶顶====')
      this.$emit('backDate')
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
<style lang="less" scoped>
img {
  width: 80px;
  height: 80px;
}

.full-width-descriptions {
  width: 100% !important;
  // background: red;
  box-sizing: border-box;
  /* 确保包含内边距和边框 */
}

/deep/.ant-descriptions-item {
  width: 100%;
  // background: red;
}

.ant-descriptions-item-label {
  width: 100px;
  // background: red;
  text-align: left;
}
.full-width-descriptions /deep/ .ant-descriptions-item-label {
  width: 200px;
  min-width: 200px;
  text-align: left;
}

// /deep/.ant-tabs-tab {
//   border: none !important;
//   padding-top: 0 !important;
// }</style>